import { useState } from 'react';
import { apiClient } from '@/api/client';
import type { Recommendation } from '../../amplify/functions/recommendations/handler';

interface RecommendParams {
  prompt?: string;
  context?: 'CELLAR' | 'BUY' | 'PAIRING';
  foodItem?: string;
}

export function useRecommendations() {
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState<Recommendation[]>([]);
  const [error, setError] = useState('');

  async function recommend(params: RecommendParams) {
    setLoading(true);
    setError('');
    try {
      const response = await apiClient.queries.getRecommendations({
        prompt: params.prompt,
        context: params.context ?? 'BUY',
        foodItem: params.foodItem,
      });

      const data = response.data as Recommendation[] | null;
      setResults(data ?? []);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not get recommendations');
    } finally {
      setLoading(false);
    }
  }

  function reset() {
    setResults([]);
    setError('');
  }

  return { recommend, loading, results, error, reset };
}
